import { Injectable } from '@angular/core';
import { Router, RoutesRecognized } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { filter, pairwise } from 'rxjs/operators';

@Injectable()
export class RouteEventsService {

    // save the previous route
  public previousRoutePath = new BehaviorSubject<string>('');

  constructor(private router: Router) {
    // setting initial previous path to hard-coded value
    this.previousRoutePath.next('/main/new-sales-dashboard');

    // on every route change take the two events of two routes changed(using pairwise)
    // and save the old one in a behavious subject to access it in another component
    // we can use if another component like intro-advertise need the previous route
    // because if we need to redirect the user to where he did came from.

    this.router.events
      .pipe(
        filter(e => e instanceof RoutesRecognized),
        pairwise())
      .subscribe((event: any[]) => {
        this.previousRoutePath.next(event[0].urlAfterRedirects);
      });

  }
}
